import { Outlet, Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, QrCode, Trophy, Sparkles, Newspaper, CalendarDays, HeartHandshake, Facebook } from "lucide-react";
import InstallAppBanner from "@/components/InstallAppBanner";

export default function MemberLayout() {
  const { logout, user } = useAuth();
  const navCls = ({ isActive }) =>
    `inline-flex items-center gap-1.5 text-sm font-semibold px-3 py-1.5 rounded-full transition-colors ${
      isActive ? "bg-[#E05638] text-white" : "text-slate-600 hover:bg-slate-100"}`;
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <InstallAppBanner />
      <header className="sticky top-0 z-10 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
          <Link to="/" className="font-heading font-extrabold text-lg text-slate-900">
            PROXI<span className="text-[#E05638]">reduc</span>-28
          </Link>
          <button
            onClick={logout}
            data-testid="member-logout"
            className="inline-flex items-center gap-1.5 text-xs text-slate-600 hover:text-slate-900"
          >
            <LogOut size={14} /> Déconnexion
          </button>
        </div>
        {user?.first_name && (
          <div className="max-w-6xl mx-auto px-4 pb-1 text-xs text-slate-500">
            Bonjour {user.first_name}
          </div>
        )}
        <div className="max-w-6xl mx-auto px-4 pb-3 flex items-center flex-wrap gap-2">
          <NavLink to="/mon-pass" className={navCls} data-testid="member-nav-pass"><QrCode size={15} /> Mon Pass</NavLink>
          <NavLink to="/mes-recompenses" className={navCls} data-testid="member-nav-rewards"><Trophy size={15} /> Mes récompenses</NavLink>
          <NavLink to="/partager-article" className={navCls} data-testid="member-nav-blog-share"><Newspaper size={15} /> Partager un article de blog</NavLink>
          <NavLink to="/partager-actualite" className={navCls} data-testid="member-nav-press-share"><Newspaper size={15} /> Partager un article d'actualité</NavLink>
          <NavLink to="/partager-evenement" className={navCls} data-testid="member-nav-event-share"><CalendarDays size={15} /> Partager un événement</NavLink>
          <NavLink to="/partager-entre-voisins" className={navCls} data-testid="member-nav-voisin-share"><HeartHandshake size={15} /> Partager une entraide Entre Voisins</NavLink>
          <NavLink to="/publier-facebook" className={navCls} data-testid="member-nav-fbposts"><Facebook size={15} /> Publier sur Facebook/Réseaux sociaux</NavLink>
          <NavLink to="/mon-assistant-ia" data-testid="member-nav-ai"
            className={({ isActive }) => `inline-flex items-center gap-1.5 text-sm font-semibold px-3 py-1.5 rounded-full transition-colors ${isActive ? "bg-[#E05638] text-white" : "text-[#E05638] hover:bg-orange-50"}`}>
            <Sparkles size={15} /> Mon Agent IA
          </NavLink>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
